import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=00cdff52&scoped=true&"
import script from "./Tables.vue?vue&type=script&lang=js&"
export * from "./Tables.vue?vue&type=script&lang=js&"
import style0 from "./Tables.vue?vue&type=style&index=0&id=00cdff52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cdff52",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheEcharts: require('/web/components/TheEcharts.vue').default})
